import { computed } from 'mobx';
import { Environment } from '@app/AppConstants';

/** The application this deployment served for the requested DNS name, emitted by HttpSecurityMiddleware. */
export type AppTenant = {
    id: number;
    code: string;
    name: string;
};

declare global {
    /* tslint:disable */
    interface Window {
        environment: string;
        appVersion: string;
        appTenant: AppTenant;
    }
    /* tslint:enable */
}

class DevInfoStore {

    get envClassName(): string {
        return window.environment.toLocaleLowerCase();
    }
    
    @computed
    get envColor(): string {
        switch (this.appEnvironment) {
            case Environment.Development:
                return 'red';
            case Environment.Staging:
                return 'yellow';
            case Environment.Production:
                return 'green';
            default:
                return 'gray';
        }
    }
    
    @computed
    get appVersion(): string {
        return window.appVersion;
    }

    @computed
    get appEnvironment(): string {
        return window.environment.toUpperCase();
    }

    @computed
    get appName(): string {
        return window.appTenant.name;
    }

    /** Short form for the collapsed navigation sidebar, e.g. 'DCC'. */
    @computed
    get appCode(): string {
        return window.appTenant.code;
    }

    @computed
    get isDevelopment(): boolean {
        return this.appEnvironment === Environment.Development;
    }
}

export const devInfoStore = new DevInfoStore();